import axios from 'axios';

const getPdfShare = async (payload) => {
    const response = await axios.post('/api/kinto/share_simulation_pdf/', payload, {
        headers: {
            'X-CSRFToken': document.querySelector('meta[name ="csrf-token"]').content
        },
        responseType: 'blob'
    });

    return response;
};

export { getPdfShare };
